/**
 * useFeedbackContext — auto-captures context for feedback submissions.
 * Grabs route, sport, build hash, viewport dimensions, connection status.
 */

import { useLocation } from 'react-router-dom';

export interface FeedbackContext {
  route: string;
  sport?: string;
  marketType?: string;
  buildHash?: string;
  viewport: string;
  connectionStatus: string;
}

export function useFeedbackContext(isConnected: boolean): FeedbackContext {
  const location = useLocation();

  // Extract sport/marketType from URL if present (e.g., /app/dashboard?sport=nba)
  const params = new URLSearchParams(location.search);
  const sport = params.get('sport') ?? undefined;
  const marketType = params.get('marketType') ?? undefined;

  const buildHash =
    (document.querySelector('meta[name="build-hash"]')?.getAttribute('content') ??
      ((window as unknown as Record<string, unknown>).__BUILD_HASH__ as string)) ||
    undefined;

  const viewport = `${window.innerWidth}x${window.innerHeight}`;
  const connectionStatus = isConnected ? 'connected' : 'disconnected';

  return {
    route: location.pathname,
    sport,
    marketType,
    buildHash,
    viewport,
    connectionStatus,
  };
}
